<div *ngIf="modalIsVisible" class="modal-overlay">
    <form class="modal">
        <div class="close-btn">
            <span class="my-color-blue">{{'__CALENDAR_PICK_TIME__' | translate}} {{ selectedDate | amDateFormat: 'Do MMMM, y' }}</span><img (click)="closeModal()"
                                                                                                                                            src="assets/img/close-btn.svg"/>
        </div>
        <div class="time-container">
            <button *ngFor="let ts of currentDateEvent | filter : 'hidden' : false" class="time-schedules"
                    [ngClass]="{
                      'choose-blue': pickedTime && ts.model.id == pickedTime.model.id && !ts.disabled,
                      'booked': ts.status === 'confirmed' || ts.status === 'pending',
                      'disabled': ts.disabled === true && ts.status !== 'confirmed' && ts.status !== 'pending'
                    }"
                    (click)="chosenTime(ts)" [disabled]="ts.disabled">
                {{ts.title}}
            </button>
        </div>
        <button type="submit" class="btn-rounded-blue primary-bg-color" (click)="confirmTime()" [disabled]="pickedTime === null"
                [ngClass]=" {'disabled': pickedTime === null }">
            <span>{{'__JOURNEY_CONFIRM__' | translate}}</span>
        </button>
    </form>
</div>

<div class="shadow-container">
    <div class="coach-head" *ngIf="this.coach !== null">
        <app-inline-svg *ngIf="isBack" class="back-arrow" [file]="'assets/img/back-blue.svg'" (click)="goBack()"></app-inline-svg>

        <div class="white-group content-wrap">
            <div class="coach-profile-photo">
                <img [src]="coach.file === null ? 'assets/img/user-blue.svg' : coach.file.url"/>
            </div>
            <div class="coach-personal-info">
                <div class="coach-name">{{coach.full_name}}</div>
                <div class="coach-speciality my-color-blue">{{coach.job_title}}</div>
            </div>
        </div>
    </div>


    <div class="coach-head" *ngIf="this.coach === null">
        <app-inline-svg *ngIf="isBack" class="back-arrow" [file]="'assets/img/back-blue.svg'" (click)="goBack()"></app-inline-svg>

        <div class="white-group content-wrap">
            <div class="coach-profile-photo">
                <ion-skeleton-text animated></ion-skeleton-text>
            </div>
            <div class="coach-personal-info">
                <div class="coach-name">
                    <ion-skeleton-text animated></ion-skeleton-text>
                </div>
                <div class="coach-speciality">
                    <ion-skeleton-text animated style="width: 15rem; height: 1rem"></ion-skeleton-text>
                </div>
            </div>
        </div>
    </div>


    <div class="month-availability">
        <div class="month">{{ viewTitle }}</div>
        <div class="availability">
            <img src="assets/img/availability-round.svg"/>
            <div>{{'__CALENDAR_AVAIL_DATES__' | translate}}</div>
        </div>
    </div>

    <div *ngIf="!profileForm">
        <ion-skeleton-text animated style="width: calc(100% - 4rem); height: 6rem; margin: auto 2rem"></ion-skeleton-text>
    </div>

    <form class="title-panel" *ngIf="profileForm" [formGroup]="profileForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="title-box">
            <label>{{'__CALENDAR_TITLE_LABEL__' | translate}}</label>

            <ng-select *ngIf="coach" class="My-dropdown blue" formControlName="title" (ngModelChange)="onTitleChanged($event)"
                       [searchable]="false" [clearable]="false"
                       (focusin)="$event.stopPropagation()"
                       [notFoundText]="'__NG_SELECT_NO_ITEMS_FOUND__' | translate"
                       [placeholder]="'__CALENDAR_SELECT_PLACEHOLDER__' | translate">
                <ng-option *ngFor="let item of coach.session_titles" [value]="item" [disabled]="item.max_sessions > 0 && item.remaining === 0">
                    {{ item.title }}
                    {{ item.max_sessions > 0 ? ('__COACHING_JOURNEY_BOX2_TITLE3_REMAINING__' | translate : {'remaining': item.remaining}) : '' }}
                </ng-option>
            </ng-select>

            <div *ngIf="!coach">
                <ion-skeleton-text animated style="width: 100%; height: 0.1rem"></ion-skeleton-text>
            </div>
        </div>

        <div class="title-box">
            <label>{{'__CALENDAR_MEETING_TYPE_LABEL__' | translate}}</label>

            <ng-select *ngIf="coach" class="My-dropdown blue" formControlName="type"
                       [searchable]="false" [clearable]="false"
                       (focusin)="$event.stopPropagation()"
                       [notFoundText]="'__NG_SELECT_NO_ITEMS_FOUND__' | translate"
                       [placeholder]="'__CALENDAR_SELECT_PLACEHOLDER__' | translate">
                <ng-option *ngFor="let item of availableTypes" [value]="item.code">
                    {{item.title | translate}}
                </ng-option>
            </ng-select>

            <div *ngIf="!coach">
                <ion-skeleton-text animated style="width: 100%; height: 0.1rem"></ion-skeleton-text>
            </div>
        </div>

        <button class="calendar-confirm-btn primary-bg-color" [disabled]="profileForm.status !== 'VALID' || pickedTime === null"
                [ngClass]=" {'disabled': profileForm.status !== 'VALID' || pickedTime === null }">
            <img [src]="profileForm.status !== 'VALID' || pickedTime === null ? 'assets/icon/calendar-confirm-icon-gray.svg' : 'assets/icon/calendar-confirm-icon.svg'">
            <span>{{'__CALENDAR_CONFIRM_SELECTION__' | translate}}</span>
        </button>
    </form>
    <div class="remember-text">
        {{'__CALENDAR_REMEMBER_TEXT__' | translate}}

        <span class="remember my-color-blue">
                    {{'__CALENDAR_REMEMBER_TEXT_BLUE__' | translate}}
                </span>
    </div>
    <div class="calendar">

        <ion-row>
            <!-- Move back one screen of the slides -->
            <ion-col size="1">
                <ion-button fill="clear" (click)="back()" [disabled]="lockSwipeToPrev">
                    <img [src]="lockSwipeToPrev ? 'assets/img/previous-grey.svg' : 'assets/img/previous-blue.svg'" alt=""/>
                </ion-button>
            </ion-col>

            <ion-col size="10" class="ion-text-center" *ngIf="isCalendar">
                <calendar [eventSource]="eventSource" [calendarMode]="calendar.mode"
                          [currentDate]="calendar.currentDate"
                          (onTimeSelected)="onTimeSelected($event)"
                          (onTitleChanged)="onViewTitleChanged($event)"
                          [queryMode] = "'remote'"
                          (onRangeChanged)="onRangeChanged($event)"
                          (onCurrentDateChanged)="onCurrentDateChanged($event)"
                          [lockSwipeToPrev]="lockSwipeToPrev"
                          [lockSwipes]="lockSwipes"
                          [locale]="userService.userInfo.language.code"
                >
                </calendar>
            </ion-col>
            <ion-col size="10" class="calendar-skeleton-wrap ion-text-center" *ngIf="!isCalendar">
                <div class="calendar-skeleton-row" *ngFor="let i of [0,1,2,3,4]">
                    <ion-skeleton-text animated *ngFor="let i of [0,1,2,3,4,5,6]"></ion-skeleton-text>
                </div>
            </ion-col>

            <!-- Move forward one screen of the slides -->
            <ion-col size="1">
                <ion-button fill="clear" (click)="next()">
                    <img src="assets/img/next-blue.svg" alt=""/>
                </ion-button>
            </ion-col>
        </ion-row>
    </div>
    <div class="time-panel">
        <img class="clock" [src]="pickedTime ? 'assets/img/clock-blue.svg' : 'assets/img/clock-grey.svg'"/>
        <div class="time-container">
            <button *ngFor="let ts of currentDateEvent | filter : 'hidden' : false" class="time-schedules"
                    [ngClass]="{
                        'choose-blue': pickedTime && ts.model.id == pickedTime.model.id && !ts.disabled,
                        'booked': ts.status === 'confirmed' || ts.status === 'pending',
                        'disabled': ts.disabled === true && ts.status !== 'confirmed' && ts.status !== 'pending'
                        }"
                    (click)="chosenTime(ts)" [disabled]="ts.disabled === true">
                {{ts.title}}
            </button>

        </div>

        <img src="assets/img/arrow-down.svg" (click)="modalIsVisible = !modalIsVisible"
             *ngIf="currentDateEvent.length !== 0"/>
    </div>
</div>
